/* eslint-disable */
import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;

const DEFAULT_HEADERS = {
  "Cache-Control": "no-cache",
  Accept: "application/json",
  "Content-Type": "application/json"
};

/*
 * Returns default headers list
 * which will be used with every request.
 */
function getHeaders(localstorage = false) {
  let defaultHeaders = DEFAULT_HEADERS;
  let token = window.$cookies.get('SESSION');
  if (token && !localstorage) {
    defaultHeaders = {
      Authorization: `Bearer ${token}`,
      ...defaultHeaders
    };
  } else {
    const localToken = JSON.parse(localStorage.getItem("user"));
    if (localToken !== null) {
      defaultHeaders = {
        Authorization: `Bearer ${localToken}`,
        ...defaultHeaders
      };
    }
  }
  return defaultHeaders;
}

export const axiosService = {
  processAPIErrors,
  esc,
  qs,
  post,
  register,
  get,
  e
};

export function processAPIErrors(apiErrors) {
  let errors = {};

  if (apiErrors) {
    for (let key of Object.keys(apiErrors)) {
      let err = apiErrors[key];

      errors[key] = err;

      if (typeof err === Object || err.hasOwnProperty("length")) {
        errors[key] = apiErrors[key][0];
      }
    }
  }

  return errors;
}

export const esc = encodeURIComponent;

export function qs(params) {
  return Object.keys(params)
    .map(k => esc(k) + "=" + esc(params[k]))
    .join("&");
}

/*
 * Wraps axios and provides
 * more convenient post method
 * calls with data
 */
export function post(uri, data) {
  return axios.post(uri, data, {
    headers: getHeaders(),
    withCredentials: true
  });
}

/*
 * Wraps axios and provides
 * more convenient post method
 * calls with data
 */
export function register(uri, data) {
  return axios.post(uri, data, {
    headers: getHeaders(),
    withCredentials: true
  });
}

/*
 * Wraps axios and provides
 * more convenient get method
 * calls with data.
 */
export function get(uri, data) {
  return axios.get(uri, {
    withCredentials: true,
    headers: getHeaders(),
    credentials: "same-origin"
  });
}

// Means endpoint
export function e(uri) {
  return BASE_URL + uri;
}
/* eslint-enable */
